export const EntityType = {
  USER_TRAVELLERS: "user_travellers",
};

export const QueryKeys = {
  userTravellers: () => [EntityType.USER_TRAVELLERS, "LIST"],
};
